import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import useApi from "../Api/Api";
import Input from "../Components/Input";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import Button from "../Components/Button";
import AddArtist from "../Forms/AddArtist";
import AdminDiv from "../AdminDiv";
import ArtistsLayout from "./ArtistsLayout";

const Artists = () => {
  const api = useApi();
  const [artists, setArtists] = useState([]);
  const [showArtistDrawer, setShowArtistDrawer] = useState(false);

  const handleShowArtistDrawer = () => {
    setShowArtistDrawer(!showArtistDrawer);
  };

  let firstLetters = [...new Set(artists.map((artist) => artist.name.charAt(0).toUpperCase()))];

  let firstNumbers = firstLetters.filter((each) => parseInt(each) < 10);

  const [searchFilter, setSearchFilter] = useState();

  const [searchTimeout, setSearchTimeout] = useState();

  const handleSearchChange = (e) => {
    setSearchTimeout(e.target.value);
  };

  useEffect(() => {
    const delaySearch = setTimeout(() => {
      setSearchFilter(searchTimeout);
    }, 500);

    return () => clearTimeout(delaySearch);
  }, [searchTimeout, setSearchFilter]);

  const getArtists = useCallback(() => {
    let queryParams = {};
    if (searchFilter) {
      queryParams.query = searchFilter;
    }
    const queryString = Object.keys(queryParams)
      .map((param) => `${param}=${queryParams[param]}`)
      .join("&");
    api.get(`/artists?${queryString}`).then((r) => {
      setArtists(r.data);
    });
  }, [api, setArtists, searchFilter]);

  useEffect(() => {
    getArtists();
  }, [getArtists]);

  return (
    <ArtistsLayout>
      <div className="text-black bg-gray-100 pt-2 pb-8">
        {showArtistDrawer && (
          <AddArtist handleShowArtistDrawer={handleShowArtistDrawer} getArtists={getArtists}></AddArtist>
        )}
        <div className={showArtistDrawer ? "blur" : ""}>
          <div className="mt-8 mx-8 py-10 px-12 text-black bg-white rounded-lg border">
            <div className="flex justify-end text-sm">
              <span className="text-white h-8 mb-1">-</span>
              <AdminDiv>
                {!showArtistDrawer && (
                  <Button onClick={handleShowArtistDrawer} className="button" text="New artist"></Button>
                )}
              </AdminDiv>
            </div>
            <div className="text-2xl -mt-4 pb-10 font-medium">Artist Listing</div>
            <div className="absolute mt-2 ml-2 text-black">
              <FontAwesomeIcon icon={faSearch}></FontAwesomeIcon>
            </div>
            <div className="w-1/2 mr-2 text-sm">
              <Input
                onChange={handleSearchChange}
                value={searchTimeout}
                placeholder="Search for artists"
                bigPaddingLeft
              />
            </div>
            <div>
              {firstNumbers.length > 0 && (
                <>
                  <div className="text-blue-500 mt-10 mb-6 text-lg font-semibold">#</div>
                  <hr></hr>
                </>
              )}
              {firstLetters.map((letter) => (
                <div className="font-semibold" key={letter}>
                  {parseInt(letter) < 10 ? null : (
                    <>
                      <div className="text-blue-500 mt-10 mb-6 text-lg">{letter}</div>
                      <hr></hr>
                    </>
                  )}
                  <div>
                    {artists.map((artist) => (
                      <div key={artist.id}>
                        {artist.name.charAt(0).toUpperCase() === letter && (
                          <>
                            <Link to={`/artists/${artist.id}`}>
                              <div className="my-7 text-sm">
                                {artist.name}
                                {artist.active || " (inactive)"}
                              </div>
                            </Link>
                            <hr></hr>
                          </>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </ArtistsLayout>
  );
};

export default Artists;
